[
  {
    "id": "1",
    "name": "Secret Note #1",
    "type": "secret-note",
    "description": "It's a page from Abigail's Diary 'Things I love: the smell of carved pumpkin, keeping an amethyst under my pillow, chocolate cake, the thrill of spicy eel, and the comfort of Mom's blackberry cobbler (I like to eat!)'"
  },
  {
    "id": "2",
    "name": "Secret Note #2",
    "type": "secret-note",
    "description": "It's Sam's holiday shopping list Everyone's favorites Sebastian: Frozen Tear, Sashimi Penny: Emerald, Poppy Vincent: Grape, Cranberry Candy Mom: Crispy Bass, Pancakes Dad: Risotto, Roasted Hazelnuts Me: Cactus, Maple Bar, Pizza"
  },
  {
    "id": "3",
    "name": "Secret Note #3",
    "type": "secret-note",
    "description": "It's written in Leah's handwriting My idea of a perfect dinner would be salad, goat cheese, truffle, and wine. For dessert I'd need a poppyseed muffin. Yum! If someone gave me one of those things, I'd melt."
  },
  {
    "id": "4",
    "name": "Secret Note #4",
    "type": "secret-note",
    "description": "It's a note of Maru's Parts still needed for my greatest invention yet! *Gold Bar *Iridium Bar *Battery Pack *Diamond *Strawberries"
  },
  {
    "id": "5",
    "name": "Secret Note #5",
    "type": "secret-note",
    "description": "It's Penny's handwriting: I want to get everyone something they love! Mom: Parsnip, Glazed Yams, NO BEER! Jas: Fairy Rose, Plum Pudding Vincent: Pink Cake, Grape Mr. Mullner: Leek, Fried Mushroom Granny Mullner: Beet, Tulip"
  },
  {
    "id": "6",
    "name": "Secret Note #6",
    "type": "secret-note",
    "description": "Stardrop Saloon Special Orders Mayor Lewis: Autumn's Bounty (Double order of high-fiber bread on the side) Marnie: Pumpkin Pie (extra whipped cream!) Demetrius: Bean Hotpot (Make it spicy) Caroline: Fish Taco (she wants triple the sauce! Better throw in a few extra napkins...)"
  },
  {
    "id": "7",
    "name": "Secret Note #7",
    "type": "secret-note",
    "description": "It's a page from someone's diary... ...There are only a few 'older' bachelors in town, and none of them are perfect! Harvey is really anxious and weak, but I know he would make a loyal and devoted husband. He likes coffee and pickles. Elliott is a bit foppish and melodramatic, but he does have a nice chin. He likes crab cakes and pomegranates. Shane is messy and anti-social. But I think his gruff exterior is a defense mechanism, insulating his softness from the world. He likes Beer, Pizza, and Pepper Poppers."
  },
  {
    "id": "8",
    "name": "Secret Note #8",
    "type": "secret-note",
    "description": "To Haley and Emily Hope you two are doing well! We've sent you your favorite gifts: Pink Cake and Sunflowers for Haley, Gemstones and Wool for Emily! -Love Mom and Dad"
  },
  {
    "id": "9",
    "name": "Secret Note #9",
    "type": "secret-note",
    "description": "Alex's Strength Training Diet: *Complete Breakfast *Salmon Dinner (I've learned to love this food... I can feel the protein!!)"
  },
  {
    "id": "10",
    "name": "Secret Note #10",
    "type": "secret-note",
    "description": "Someone is waiting for you on level 100 in the skull cavern..."
  },
  {
    "id": "11",
    "name": "Secret Note #11",
    "type": "secret-note",
    "description": "An image-only note depicting a crow standing on a doormat in front of a house."
  },
  {
    "id": "12",
    "name": "Secret Note #12",
    "type": "secret-note",
    "description": "I've found some good things by looking in the garbage cans, on lucky days. Sometimes you'll find the 'dish of the day' behind the saloon... usually fresh! For dessert, I'll check the Mullners' can for cookies. For treasures, check the cans by the blacksmith and museum."
  },
  {
    "id": "13",
    "name": "Secret Note #13",
    "type": "secret-note",
    "description": "12 o'clock noon SHARP. Last day of the season. Check the bush above the playground."
  },
  {
    "id": "14",
    "name": "Secret Note #14",
    "type": "secret-note",
    "description": "I hid something behind the community center."
  },
  {
    "id": "15",
    "name": "Secret Note #15",
    "type": "secret-note",
    "description": "Mermaid Show: 1-5-4-2-3"
  },
  {
    "id": "16",
    "name": "Secret Note #16",
    "type": "secret-note",
    "description": "An image-only note showing a series of fishing illustrations."
  },
  {
    "id": "17",
    "name": "Secret Note #17",
    "type": "secret-note",
    "description": "An image-only note showing crop growth stages."
  },
  {
    "id": "18",
    "name": "Secret Note #18",
    "type": "secret-note",
    "description": "An image-only note showing a mining sequence."
  },
  {
    "id": "19",
    "name": "Secret Note #19",
    "type": "secret-note",
    "description": "An image-only note depicting a puzzle scene."
  },
  {
    "id": "20",
    "name": "Secret Note #20",
    "type": "secret-note",
    "description": "An image-only note depicting a puzzle scene."
  },
  {
    "id": "21",
    "name": "Secret Note #21",
    "type": "secret-note",
    "description": "An image-only note depicting a puzzle scene."
  },
  {
    "id": "22",
    "name": "Secret Note #22",
    "type": "secret-note",
    "description": "Greetings, farmer... Have you found my 'secret' in the dark tunnel? I look forward to meeting you! -Qi"
  },
  {
    "id": "23",
    "name": "Secret Note #23",
    "type": "secret-note",
    "description": "If yoo can reed dis... come to seecrit wuds. Pleez bring may-pal serrup."
  },
  {
    "id": "24",
    "name": "Secret Note #24",
    "type": "secret-note",
    "description": "It's a page from M. Jasper's book: ...the creatures, known by some as \"Forest Spirits\" or \"Junimos\", are said to appear in abandoned buildings after they've \"gone to seed\". As a general rule... when humans leave, and nature begins to reclaim her territory, the Junimos will undoubtedly appear. Folk wisdom holds that the Junimos display some kind of resonant affinity with gemstones that are placed inside their little huts... Also, it's said that raisins are their favorite food, but they are too shy to take them directly from the hand. Of course, all these claims come from dubious, unverified sources... As far as I know, even the mere existence of these creatures has never been proven!"
  },
  {
    "id": "25",
    "name": "Secret Note #25",
    "type": "secret-note",
    "description": "I 'borrowed' a necklace from Mom, but lost it somewhere near the bath house... She's going to freak out if she notices it's missing!"
  },
  {
    "id": "26",
    "name": "Secret Note #26",
    "type": "secret-note",
    "description": "Ancient Farming Secrets, line 37: There's no better helper than a raisin-fed Junimo..."
  },
  {
    "id": "27",
    "name": "Secret Note #27",
    "type": "secret-note",
    "description": "My dear grandchild, By the time you find this note, I expect you'll have been living in the valley for quite some time. I hope things are going well! I'm honored that you're continuing the family tradition of farming, and through that noble endeavor, bringing greater life and abundance to all of Stardew Valley... a place very dear to my heart. Keep up the good work! -Grandpa P.S. ...I've hidden a very special secret for you somewhere in the valley. You might think of it as a compendium of my greatest discoveries. Someday, when you're ready, you'll find it."
  },
  {
    "id": "1001",
    "name": "Journal Scrap #1",
    "type": "journal-scrap",
    "description": "Day 1 ...My ship is lost... Shattered by a tempest in the unforgiving sea. I find myself stranded now, on these strange shores. My crew has perished, but I still live. Perhaps lady luck has blessed these wicked bones of mine... Or has her own designs for my fate... At any rate, I've no choice but to make a life for myself here. There's fresh water in abundance, food to forage, and fertile soil to work. First I'll build a shelter... (There are some pages missing)"
  },
  {
    "id": "1002",
    "name": "Journal Scrap #2",
    "type": "journal-scrap",
    "description": "Day 6 I won't go hungry here... the waters are full of edible (nay, delicious!) fish. I even caught a stingray in the caves by the southeast shore. I haven't a clue what to do with it, though! The other day, I even fished up a couple of golden walnuts. They seem to be all over the island. The local parrots go crazy for them!"
  },
  {
    "id": "1003",
    "name": "Journal Scrap #3",
    "type": "journal-scrap",
    "description": "Day 14 After half a month on this island, I've learned a thing or two about finding these golden nuts. One must keep their eyes peeled for subtle clues. If something looks unusual, there may be a hidden nut nearby. I've noticed signs in the sand... and signs in the leaves... I even saw a nut up in a tree near the volcano. If only I had a way of shooting it down... Whenever I've spotted a nut plant, I've always found a way to reach it."
  },
  {
    "id": "1004",
    "name": "Journal Scrap #4",
    "type": "journal-scrap",
    "description": "An image-only journal scrap showing a map of the island."
  },
  {
    "id": "1005",
    "name": "Journal Scrap #5",
    "type": "journal-scrap",
    "description": "Day 23 The local volcano holds many secrets. I've seen little men with glowing eyes, skittering about in the dark... like cats in the night. (Could these be the fabled dwarf-men, mentioned by M. Jasper in his 'Famous Journeys'?) Strange machines, too. Uncanny... not like anything known to man. At the top, I found a passage to the caldera of the volcano. And, half submerged in the bubbling lava, a peculiar machine... a kind of \"forge\". I'll investigate further tomorrow."
  },
  {
    "id": "1006",
    "name": "Journal Scrap #6",
    "type": "journal-scrap",
    "description": "An image-only journal scrap showing a map of the island."
  },
  {
    "id": "1007",
    "name": "Journal Scrap #7",
    "type": "journal-scrap",
    "description": "--Forging Table-- Topaz -- Defense Emerald -- Speed Jade -- Critical Strike Power Aquamarine -- Critical Strike Chance Amethyst -- Knockback Ruby -- Damage Prismatic Shard -- Enchantment Note: Weapons can be forged up to 3 times with gems, and can also be enchanted once with a prismatic shard. Note 2: 'Innate Enchantments', (meaning those powers that sometimes appear on weapons when you first acquire them), can also be added or re-discovered using a Dragon Tooth. It's theorized that this cannot be done to weapons above a certain caliber. Tools can only be enchanted, not forged."
  },
  {
    "id": "1008",
    "name": "Journal Scrap #8",
    "type": "journal-scrap",
    "description": "--Weapon Enchantments-- Artful: Allows you to do \"special moves\" more rapidly Bug Killer: Do more damage to bugs. Vampiric: Occasionally siphon health from a monster. Crusader: Do more damage to \"unholy\" monsters. Haymaker: When cutting weeds, you get more fiber, and also a chance to collect hay. --Tool Enchantments-- Powerful: Do more tool damage to stones, trees, and the like. Reaching: Increases your charge-up capacity, for a greater area of effect. Shaving: Chance to peel off additional wood when chopping. Bottomless: Watering can will never run dry. Generous: Dig up more from beneath the earth. Archaeologist: Greater chance to find artifacts and bones. Efficient: Takes no energy to use. Swift: Swing the tool faster. Master: Increases fishing level. Auto-Hook: Automatically hooks fish when they bite. Preserving: Bait and tackle have a 50% chance to not be consumed."
  },
  {
    "id": "1009",
    "name": "Journal Scrap #9",
    "type": "journal-scrap",
    "description": "'Twas a rain drenched day, and upon a lonely rock a beautiful maiden saw I Tales I'd heard of sea-born maidens singing siren's songs, Yet nary a note could she muster... The next morning I spied an arrangement of stone upon the foamy bank... ----------------- Aye... stones as big as 'ones' and stones as big as 'fives' were they... ----------------- If but this harried sea dog a tune could howl, perhaps to Blackgull's treasure would she lead..."
  },
  {
    "id": "1010",
    "name": "Journal Scrap #10",
    "type": "journal-scrap",
    "description": "An image-only journal scrap showing a stone arrangement puzzle."
  },
  {
    "id": "1011",
    "name": "Journal Scrap #11",
    "type": "journal-scrap",
    "description": "Day 37 When I was a boy of ten years old, my father gave me a glow ring and a magnet ring. They've never left my fingers since. However, when I was standing on top of the volcano... a strange idea came over me. I took my two rings, and cast them into the forge. Lo and behold! They combined into one! Now I've got one glowing magnet ring... I hope old pappy doesn't mind, rest his soul..."
  }
]
